<template>
  <el-row>
    <el-col :span="24">
      <RegionCascade
        v-model="region"
        @change="handleChange"
        :isdisabled="isdisabled"
      />
    </el-col>
    <el-col :span="24">
      <el-input
        v-model="detail"
        placeholder="请输入详细地址"
        :maxlength="100"
        :disabled="isdisabled"
        @blur=""
      ></el-input>
    </el-col>
  </el-row>
</template>

<script>
import RegionCascade from "../RegionCascade";
export default {
  name: "BaseRegion",
  model: {
    event: "change",
    value: "value"
  },
  components: {
    RegionCascade
  },
  props: {
    value: {
      type: [String, Object]
    },
    isdisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      region: {},
      detail: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(data) {
        if (!data && typeof data === "string") {
          this.region = {};
          this.detail = "";
        } else {
          this.region = data;
          this.detail = data.detail;
        }
        // this.handleChange()
      }
    },
    detail() {
      console.log(this.detail);
      this.handleChange();
    }
  },
  methods: {
    handleChange() {
      this.$emit("change", {
        ...this.region,
        detail: this.detail.trim()
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BaseRegion/index.vue